import { render, staticRenderFns } from "./ConfiguracaoAlmoxarifadoUnidadeAdministrativa.vue?vue&type=template&id=a5c2ccde"
import script from "./ConfiguracaoAlmoxarifadoUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoAlmoxarifadoUnidadeAdministrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports